import { Category } from './types';

export const CATEGORIES: Category[] = [
  { id: "stem", label: "STEM Careers", description: "Science, engineering, tech, and math careers.", order: 1 },
  { id: "creative", label: "Creative Careers", description: "Design, media, animation, and creative tech.", order: 2 },
  { id: "health", label: "Health Careers", description: "Healthcare and wellbeing careers.", order: 3 },
  { id: "business", label: "Business Careers", description: "Leadership, marketing, policy, and impact.", order: 4 },
  { id: "digital", label: "Digital & Media", description: "Future jobs and digital careers.", order: 5 },
  { id: "trades", label: "Skilled Trades", description: "Hands-on skilled technical careers.", order: 6 },
];

export const PLACEHOLDER_IMAGES = {
  card: '/images/careers/_placeholders/fpt-placeholder-card.webp',
  thumb: '/images/careers/_placeholders/fpt-placeholder-thumb.webp',
  hero: '/images/careers/_placeholders/fpt-placeholder-card.webp',
  sidebar: '/images/careers/_placeholders/fpt-placeholder-card.webp'
};

export const SITE_URL = "https://futurepathteens.com";

/**
 * Normalizes a path to be an absolute public URL.
 * Also handles potential double slashes and ensures relative paths work in dev/prod.
 */
export const toPublicUrl = (p?: string) => {
  if (!p) return "";
  // If it's already a full URL, return it
  if (p.startsWith('http')) return p;
  
  // Ensure single leading slash
  const cleaned = p.startsWith('/') ? p : `/${p}`;
  return cleaned.replace(/\/+/g, '/');
};

/**
 * Returns a branded remote placeholder if local assets are missing.
 */
export const getRemoteFallback = (text: string, width: number, height: number) => {
  const bg = "0B2A33"; // Brand Dark
  const fg = "21D4FD"; // Brand Cyan
  return `https://placehold.co/${width}x${height}/${bg}/${fg}?text=${encodeURIComponent(text)}`;
};
